import { Component, OnInit, inject } from '@angular/core';
import {GameService} from "./services/game.service";
import {Router} from "@angular/router";
import {MatDialog} from "@angular/material/dialog";
import {SwUpdate} from "@angular/service-worker";
import {DialogUpdateAppComponent} from "./components/dialog-update-app/dialog-update-app.component";
import {animate, state, style, transition, trigger} from "@angular/animations";
import {LanguageService} from "./services/language.service";
import {DebugService} from "./services/debug.service";
import {LoadingService} from "./services/loading.service";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    animations: [
        trigger('fadeInOut', [
            state('void', style({
                opacity: 0
            })),
            transition('void <=> *', animate(100)),
        ]),
    ],
    // TODO migration bootstrapApplication() : nécessite de convertir AngularFire compat,
    // ServiceWorkerModule, Sentry APP_INITIALIZER et le routing en providers standalone.
    // À faire en tâche séparée avec validation build + serveur dev.
    // eslint-disable-next-line @angular-eslint/prefer-standalone
    standalone: false
})
export class AppComponent implements OnInit {
  game = inject(GameService);
  router = inject(Router);
  dialog = inject(MatDialog);
  private languageService = inject(LanguageService);
  private debugService = inject(DebugService);
  loadingService = inject(LoadingService);

  title = 'statsFootball';

  constructor() {
    const updates = inject(SwUpdate);


    this.detectNewAppVersion(updates);

    // Permettre d'utiliser window.chargerDonneesLineup depuis la console
    (window as any).chargerDonneesLineup = this.debugService.chargerDonneesLineup.bind(this.debugService);
  }

  ngOnInit() {
    this.languageService.loadInitialLanguage()
  }

  private detectNewAppVersion(updates: SwUpdate) {
    updates.versionUpdates.subscribe(event => {
      console.log(event.type, event)
      if (event.type === 'VERSION_READY') {
        this.dialog.open(DialogUpdateAppComponent);
      }
    });
  }
}
